<template>
  <div class="h-full min-h-full">
    <div
      v-if="!modal"
      class="flex-1 pb-8 z-0"
    >
      <div class="bg-white shadow">
        <div class="px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl">
          <div class="pt-6 pb-6 md:flex md:items-center justify-between lg:border-t lg:border-cool-gray-200">
            <div class="text-2xl font-bold leading-7 text-cool-gray-900 sm:leading-9 sm:truncate">
              {{ title }}
            </div>

            <div class="flex">
              <SecondaryButton
                v-if="secondaryAction !== ''"
                :text="secondaryAction"
                class="mr-2"
                @click="secondaryClick()"
              />

              <PrimaryButton
                :text="primaryAction"
                :icon="primaryActionIcon"
                :disabled="totalValidationErrors !== 0 || loading"
                @click="primaryClick()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="modal?'py-4 px-6 pb-6':'px-4 sm:px-6 lg:mx-auto lg:px-8 max-w-7xl ml-auto mr-auto'">
      <div
        v-for="(form, formIndex) in formServicesSorted"
        :key="`form-${formIndex}-${form.serviceName}`"
        :class="formIndex !== (formServicesLength - 1) && modal? 'pb-6' : ''"
      >
        <div :class="modal?'':'md:grid md:grid-cols-3 md:gap-6'">
          <div class="md:col-span-1">
            <div class="px-4 sm:px-0">
              <h3 class="text-lg font-medium leading-6 text-gray-900">
                {{ form.title }}
              </h3>
              <p class="mt-1 text-sm leading-5 text-gray-600">
                {{ form.description }}
              </p>
            </div>
          </div>
          <div class="mt-5 md:mt-0 md:col-span-2">
            <div :class="modal?'':'shadow sm:rounded-md'">
              <div :class="modal?'':'px-4 py-5 bg-white sm:p-6 rounded-lg'">
                <div v-if="form.service !== undefined">
                  <div
                    v-for="(field, index) in getDisplayFields(form.service.properties)"
                    :key="`field-${formIndex}-${index}-${field.name}`"
                    class="col-span-6 sm:col-span-4"
                    :class="index >= 1 ? 'mt-5' : ''"
                  >
                    <label
                      class="block text-sm font-medium leading-5 text-gray-700"
                    >
                      {{ getAttributeValue(field.attributes, 'DisplayName') }}<span
                        v-if="getAttributeValue(field.attributes, 'IsRequired')"
                        class="text-red-700"
                      >*</span>
                    </label>
                    <div
                      class="block pb-1 text-sm leading-5 text-gray-400"
                    >
                      {{ getAttributeValue(field.attributes, 'Description') }}
                    </div>

                    <div v-if="showValidation">
                      <div
                        v-for="(error, errorIndex) in getValidationErrors(form, field)"
                        :key="`error-${formIndex}-${index}-${errorIndex}`"
                        class="block pb-1 text-sm leading-5 text-red-700"
                      >
                        {{ error }}
                      </div>
                    </div>


                    <input
                      v-if="field.type === 'String'"
                      :id="form.serviceName + form.action + field.name + formIndex"
                      :placeholder="getAttributeValue(field.attributes, 'Placeholder')"
                      class="mt-1 form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 max-w-sm"
                      @input="addInput($event.target.value, field.name, form.serviceName, form.action)"
                    >
                    <!--
                    <input
                      v-if="field.type === 'DateTime' && getAttributeValue(field.attributes, 'InputType') !== 'Date'"
                      type="date"
                      class="mt-1 form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5 w-40 inline-block"
                      @input="addInput($event.target.value, field.name, form.serviceName, form.action)"
                    > -->

                    <input
                      v-if="field.type === 'DateTime' && getAttributeValue(field.attributes, 'InputType') === 'Time'"
                      type="time"
                      class="mt-1 form-input transition duration-150 ease-in-out sm:text-sm sm:leading-5 w-40 inline-block"
                      @input="addInput($event.target.value, field.name, form.serviceName, form.action)"
                    >

                    <PlayerType
                      v-if="field.type === 'PlayerType'"
                      class="mt-1 max-w-sm"
                      :placeholder="false"
                      @input="addInput($event, field.name, form.serviceName, form.action)"
                    />

                    <Days
                      v-if="field.type === 'Days'"
                      class="mt-1"
                      @input="addInput($event, field.name, form.serviceName, form.action)"
                    />

                    <input
                      v-if="field.type === 'Int32'"
                      :placeholder="getAttributeValue(field.attributes, 'Placeholder')"
                      type="number"
                      class="mt-1 form-input block transition duration-150 ease-in-out sm:text-sm sm:leading-5 w-40"
                      @input="addInput($event.target.value, field.name, form.serviceName, form.action)"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="formServicesLength > 1 && formIndex !== (formServicesLength - 1) && !modal"
          class="hidden sm:block"
        >
          <div class="py-5 pt-6">
            <div class="border-t border-gray-200" />
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="modal"
      class=""
    >
      <div class="bg-gray-50 px-4 py-3 sm:px-4 sm:flex sm:flex-row-reverse">
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <PrimaryButton
            :text="primaryAction"
            :icon="primaryActionIcon"
            :disabled="totalValidationErrors !== 0"
            @click="primaryClick()"
          />
        </span>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <SecondaryButton
            :text="secondaryAction"
            class=""
            @click="secondaryClick()"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';
import SecondaryButton from '@/app/shared/components/base/button/secondaryButton.vue';
import Days from '@/app/shared/components/form/inputs/days.vue';
import PlayerType from '@/app/shared/components/player/typeDropdown.vue';
import useForm from '@/app/shared/composables/form';
import { PrefilledField } from '@/app/shared/components/form/classes';

export default {
  name: 'Form',

  components: {
    PrimaryButton,
    SecondaryButton,
    Days,
    PlayerType,
  },

  props: {
    modal: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    secondaryAction: {
      type: String,
      default: '',
    },
    primaryAction: {
      type: String,
      default: '',
    },
    primaryActionIcon: {
      type: String,
      default: '',
    },
    forms: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      fieldsSet: false,
    };
  },

  setup(props, { emit }) {
    console.log('[Form] Component setup called');
    console.log('[Form] Props received:', {
      modal: props.modal,
      title: props.title,
      formsExists: !!props.forms,
      formsIsArray: Array.isArray(props.forms),
      formsLength: props.forms ? props.forms.length : 0,
      forms: props.forms,
    });
    return useForm(props, { emit });
  },

  computed: {
    formServicesSorted() {
      // In Vue 2 with toRefs, we need to access the ref's value property
      // to create a reactive dependency. Accessing .value is necessary for tracking.
      const formServicesRef = this.formServices;
      
      // toRefs creates refs, so we must access .value to track changes
      let formServicesValue;
      if (formServicesRef && typeof formServicesRef === 'object' && 'value' in formServicesRef) {
        // Access .value to create reactive dependency
        formServicesValue = formServicesRef.value;
      } else {
        // Fallback if not a ref
        formServicesValue = formServicesRef;
      }

      console.log('[Form] formServicesSorted computed - called:', {
        formServicesType: typeof this.formServices,
        isRef: formServicesRef && typeof formServicesRef === 'object' && 'value' in formServicesRef,
        formServicesValueType: typeof formServicesValue,
        isArray: Array.isArray(formServicesValue),
        length: formServicesValue ? formServicesValue.length : 0,
      });

      // Safety check
      if (!formServicesValue || !Array.isArray(formServicesValue) || formServicesValue.length === 0) {
        console.log('[Form] formServicesSorted - empty, returning []');
        return [];
      }

      // Create a copy and sort
      const sorted = [...formServicesValue].sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
      console.log('[Form] formServicesSorted - returning sorted:', sorted.length, 'items');
      return sorted;
    },
    
    // Helper computed to get formServices length for template
    formServicesLength() {
      const formServicesRef = this.formServices;
      let formServicesValue;
      if (formServicesRef && typeof formServicesRef === 'object' && 'value' in formServicesRef) {
        formServicesValue = formServicesRef.value;
      } else {
        formServicesValue = formServicesRef;
      }
      return formServicesValue && Array.isArray(formServicesValue) ? formServicesValue.length : 0;
    },
  },

  watch: {
    // Use a function to watch the ref's value property
    formServices() {
      // Access the ref value to create dependency
      const formServicesRef = this.formServices;
      let formServicesValue;
      if (formServicesRef && typeof formServicesRef === 'object' && 'value' in formServicesRef) {
        formServicesValue = formServicesRef.value;
      } else {
        formServicesValue = formServicesRef;
      }

      console.log('[Form] formServices watcher - checking value:', {
        exists: !!formServicesValue,
        isArray: Array.isArray(formServicesValue),
        length: formServicesValue ? formServicesValue.length : 0,
      });

      // Force update to trigger computed property re-evaluation
      if (formServicesValue && Array.isArray(formServicesValue) && formServicesValue.length > 0) {
        console.log('[Form] formServices has items, forcing update');
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
  },
  
  mounted() {
    // Set up a polling mechanism as fallback to check for formServices updates
    // This ensures forms display even if reactivity isn't working properly
    this.formServicesCheckInterval = setInterval(() => {
      const formServicesRef = this.formServices;
      let formServicesValue;
      if (formServicesRef && typeof formServicesRef === 'object' && 'value' in formServicesRef) {
        formServicesValue = formServicesRef.value;
      } else {
        formServicesValue = formServicesRef;
      }

      if (formServicesValue && Array.isArray(formServicesValue) && formServicesValue.length > 0) {
        // Check if we need to update
        const currentLength = this.formServicesSorted ? this.formServicesSorted.length : 0;
        if (formServicesValue.length !== currentLength) {
          console.log('[Form] Polling detected formServices change, forcing update');
          this.$forceUpdate();
        }
      }
    }, 500); // Check every 500ms

    // Clear interval when component is destroyed
    this.$once('hook:beforeDestroy', () => {
      if (this.formServicesCheckInterval) {
        clearInterval(this.formServicesCheckInterval);
      }
    });
  },

  methods: {
    secondaryClick() {
      this.$emit('secondaryClick');
    },

    primaryClick() {
      this.submit();
    },
  },

};
</script>
